import { render, staticRenderFns } from "./BondRecordDetail.vue?vue&type=template&id=f200d224&scoped=true"
import script from "./BondRecordDetail.vue?vue&type=script&lang=js"
export * from "./BondRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./BondRecordDetail.vue?vue&type=style&index=0&id=f200d224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f200d224",
  null
  
)

export default component.exports